import { create } from 'zustand';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://vclass.vskul.com/api/v1';

export const useAdminAuthStore = create((set, get) => ({
  admin: null,
  accessToken: null,
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      const { user, access_token } = response.data;

      // Verify user is admin
      if (user.account_type !== 'admin' && !user.is_admin) {
        throw new Error('Unauthorized: Admin access required');
      }

      set({
        admin: user,
        accessToken: access_token,
        isLoading: false,
      });

      localStorage.setItem('adminToken', access_token);
      return user;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Login failed';
      set({ error: message, isLoading: false });
      throw error;
    }
  },

  logout: async () => {
    try {
      const { accessToken } = get();
      if (accessToken) {
        await axios.post(
          `${API_URL}/auth/logout`,
          {},
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      set({ admin: null, accessToken: null, error: null });
      localStorage.removeItem('adminToken');
    }
  },

  restoreSession: () => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      set({ accessToken: token });
      return true;
    }
    return false;
  },

  setError: (error) => set({ error }),
}));
